import PropTypes from "prop-types"
import SizeChartItem from "./SizeChartItem"
import { useState, useContext } from "react"
import { StackerContext } from "components/DYStackers/StackerContext"
import "./SizeChart.scss"

const SizeChart = (props) => {
  const [inch, setInch] = useState(true)
  const { title, url } = props
  const stackerContext = useContext(StackerContext)
  const changeToCms = () => {
    setInch(!inch)
  }
  const isMen = stackerContext.gender == "men"
  const tableTitle = isMen ? "Men" : "Women"

  return (
    <div className="size-chart-wrapper">
      <h2 className="size-chart-title">{title}</h2>
      <p className="size-chart-text">
        Choose your corresponding size by comparing your wrist measurements to
        the chart below or by following the directions in our printable guide.
      </p>
      <a href={url} className="size-chart-link">
        View & Download Full Guide
      </a>
      <div className="row table-row mt-5">
        <div className="col-8">
          <p className="table-title">Wrist size</p>
          <button className="size-chart-link" onClick={changeToCms}>
            See measurements in
            <span className="inch">{inch ? " inches" : " centimeters"}</span>
          </button>
        </div>
        <div className="col-4">
          <span className="table-title">{tableTitle}</span>
        </div>
      </div>
      {isMen &&
        umMen.map((size, index) => {
          return (
            <SizeChartItem
              key={index}
              label={size.label}
              value={inch ? size.valueIn : size.valueCm}
            />
          )
        })}
      {!isMen &&
        umWomen.map((size, index) => {
          return (
            <SizeChartItem
              key={index}
              label={size.label}
              value={inch ? size.valueIn : size.valueCm}
            />
          )
        })}
    </div>
  )
}

export default SizeChart

SizeChart.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
}

const umMen = [
  {
    valueIn: "6.0 - 6.5 in",
    valueCm: "15.2 - 16.5 cm",
    label: "X-Small",
  },
  {
    valueIn: "6.5 - 7.0 in",
    valueCm: "16.5 - 17.8 cm",
    label: "Small",
  },
  {
    valueIn: "7.0 - 7.5 in",
    valueCm: "17.8 - 19.1 cm",
    label: "Medium",
  },
  {
    valueIn: "7.5 - 8.0 in",
    valueCm: "19.1 - 20.3 cm",
    label: "Large",
  },
  {
    valueIn: "8.0 - 8.5 in",
    valueCm: "20.3 - 21.6 cm",
    label: "X-Large",
  },
]

const umWomen = [
  {
    valueIn: "5.0 - 5.5 in",
    valueCm: "12.7 - 14.0 cm",
    label: "X-Small",
  },
  {
    valueIn: "5.5 - 6.0 in",
    valueCm: "14.0 - 15.2 cm",
    label: "Small",
  },
  {
    valueIn: "6.0 - 6.5 in",
    valueCm: "15.2 - 16.5 cm",
    label: "Medium",
  },
  {
    valueIn: "6.5 - 7.0 in",
    valueCm: "16.5 - 17.8 cm",
    label: "Large",
  },
  {
    valueIn: "7.0 - 7.5 in",
    valueCm: "17.8 - 19.1 cm",
    label: "X-Large",
  },
]
